import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  position: relative;
  width: 720px;
  padding: 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  box-sizing: border-box;

  border-radius: 16px;
  background: var(--alias-color-background-normal-normal);
  max-height: 696px;
`;

export const ExitBtnContainer = styled.div`
  display: flex;
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  align-self: stretch;
`;

export const HeaderContainer = styled.div`
  display: flex;
  padding: 0px 16px 16px 16px;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
  box-sizing: border-box;

  border-bottom: 2px solid var(--alias-color-line-normal);

  p {
    flex: 1;
  }
`;

export const PolicySettingContainer = styled.div`
  display: flex;
  max-height: 400px;
  width: 100%;
  overflow-y: auto;
  height: max-content;
  flex-direction: column;
`;
